import * as yup from 'yup';
import { periodsSchema } from 'components/shared/DutyCodesGrid/AddDutyCode/utils/addDutyCodeSchema';

export const dutyPeriodDialogSchema = yup.object({
  periods: periodsSchema
});
